import {
  GET_DATA_TABLEREPORT_PLANHANDLE_SUCCEEDED,
  REQUEST_DATA_TABLEREPORT_PLANHANDLE_FAILED,
  CLEAR_DATA_TABLEREPORT_PLANHANDLE,
} from "../actions/actionTypes";

const tableReportReducer = (DataTableReport = [], actions) => {
  switch (actions.type) {
    case CLEAR_DATA_TABLEREPORT_PLANHANDLE:
      return { ...DataTableReport, DataTableReport: [] };
    case GET_DATA_TABLEREPORT_PLANHANDLE_SUCCEEDED:
      if (Object.keys(actions.DataTableReport).length > 0) {
        return {
          ...DataTableReport,
          DataTableReport: actions.DataTableReport,
        };
      } else {
        return { ...DataTableReport };
      }
    case REQUEST_DATA_TABLEREPORT_PLANHANDLE_FAILED:
      return { ...DataTableReport, DataTableReport: [] };
    default:
      return { ...DataTableReport };
  }
};

export default tableReportReducer;
